import { CategoryType } from './category-type';

export class Category {
  constructor(
    public hash?: string,
    public name?: string,
    public materialCount?: number,
    public isPrint?: boolean,
    public isOutsourcing?: boolean,
    public isOther?: boolean,
    public lastUpdate?: number,
    public type?: CategoryType
  ) { }

  clone() {
    return new Category (
      this.hash,
      this.name,
      this.materialCount,
      this.isPrint,
      this.isOutsourcing,
      this.isOther,
      this.lastUpdate,
      this.type
    );
  }

  get typeName() {
    return this.type ? this.type.name : '';
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/category.ts